/* unplugin-vue-components disabled */import script from "./tableTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./tableTwo.vue?vue&type=script&setup=true&lang=js"

import "./tableTwo.vue?vue&type=style&index=0&id=57e655dd&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57e655dd"]])

export default __exports__